import { styled } from 'goober';

const SpinnerContainer = styled('div')`
  border: 3px solid #003366;
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spinner 1s linear infinite;
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Spinner = (props) => {
  return <SpinnerContainer style={props.style} />;
};
export default Spinner;



// WEBPACK FOOTER //
// ./components/checkoutWidget/Spinner.js